import { Remittance } from 'interfaces';
import { http, HttpResponse } from 'msw';
import { payorRefs, siteRefs } from '../../factories/seeds/entities';
import { mockPayors } from './payorMock';
import { mockSites } from './siteMock';

const payorByID = new Map(mockPayors.map((payor) => [payor.id, payor]));
const siteByID = new Map(mockSites.map((site) => [site.id, site]));

const remittanceSite = siteByID.get(siteRefs.qdocVirtualHealthcare.id) || null;
const mbPayor = payorByID.get(payorRefs.mb.id) || null;
const mshPayor = payorByID.get(payorRefs.msh.id) || null;
const qdocPayor = payorByID.get(payorRefs.qdoc.id) || null;
const wcbPayor = payorByID.get(payorRefs.wcb.id) || null;

export const mockRemittances: Remittance[] = [
  {
    id: '6c0ecde9-80bd-49a1-9608-d41c8248501c',
    filename: 'QDOC038H.017.txt',
    siteID: remittanceSite?.id ?? '',
    parsedAt: '2025-03-18T21:23:48.729Z',
    createdAt: '2025-03-18T21:23:48.729Z',
    totalFeeAssessed: '377.95',
    incomeFilePath: 'P4 20250317.TXT',
    payorID: mbPayor.id,
  },
  {
    id: 'c4f6e0fd-9ff9-452c-a037-88bbb8a78619',
    filename: 'msh20250318.csv',
    siteID: remittanceSite?.id ?? '',
    parsedAt: '2025-03-19T01:27:35.421Z',
    createdAt: '2025-03-19T01:27:35.421Z',
    totalFeeAssessed: '247.72',
    incomeFilePath: 'msh20250318.csv',
    payorID: mshPayor?.id ?? '',
  },
  {
    id: '7bf1ebcb-77d5-4357-8152-be74f856aca6',
    filename: 'qdoc20250320.csv',
    siteID: remittanceSite?.id ?? '',
    parsedAt: '2025-03-21T21:38:30.597Z',
    createdAt: '2025-03-21T21:38:30.597Z',
    totalFeeAssessed: '591.6',
    incomeFilePath: 'qdoc20250320.csv',
    payorID: qdocPayor?.id ?? '',
  },
  {
    id: 'c6060554-4c3a-4688-9b9d-8bb51d13a204',
    filename: 'wcb.csv',
    siteID: remittanceSite?.id ?? '',
    parsedAt: '2025-03-21T22:06:29.940Z',
    createdAt: '2025-03-21T22:06:29.940Z',
    totalFeeAssessed: '539.1',
    incomeFilePath: 'wcb.csv',
    payorID: wcbPayor?.id ?? '',
  },
];

export const mockRemittanceHandlers = [
  http.get('*/resource/remittance/site', ({ request }) => {
    const url = new URL(request.url).searchParams;
    const siteID = url.get('siteID');
    return HttpResponse.json(
      mockRemittances.filter((remittance) => remittance.siteID === siteID)
    );
  }),
  http.put('*/resource/remittance', async ({ request }) => {
    const response = await request.json();
    return HttpResponse.json(response);
  }),
];
